import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import notificationService from '../Services/notification.service'
import { toast } from 'react-toastify'
import { toastProperties } from '../../commons/Toast/Toaster'
import { getAllNotifications } from '../../store/Notification/action'
import { CircularProgress } from '@mui/material'

const NotificationsList = ({handleNotification}) => {
  const notificationsList = useSelector(state => state?.notificationReducer?.allNotifications);
  const dispatch = useDispatch();

  const handleNotificationsRead = () =>{
    notificationService.markAllNotificationsRead().then((response) =>{
      if(response?.data?.code === 200){
        toast.success(response?.data?.message,toastProperties);
        getAllNotifications()(dispatch)
        // handleNotification()
      }
    }).catch(error => console.log("Error==>",error))
  }
  return (
    <div className='notification_dropdown_menu'>
          <div className='notification_header'>
            <div className='notification_title'>Notifications</div>
            <div style={{cursor:'pointer'}} onClick={handleNotificationsRead}>Mark all as read</div>
          </div>

          {notificationsList?<div className='notification_body table-scrollY'>
          {notificationsList?.map((item,i)=>(<div key={i} className='notification_item' style={{backgroundColor: item?.readStatus ? '' : 'lightgrey'}}>
              {/* <div><TaskIcon className=' icon-orange' /> </div> */}
              <div>
                {/* <div className='account_name'>Account Name</div> */}
                <div className='action_title'>{item?.type}</div>
                <div className='action_descprition'>{item?.content}</div>
                <div className='action_time'>{item?.createdAt && moment(item?.createdAt).format("DD-MMM-yyyy HH:mm")}</div>
              </div>
            </div>))}
          </div>:<div className='text-center' style={{ maxHeight: '500px' }}>
            <CircularProgress />
          </div>}

          {/* <div className='notification_footer'>View All Notifications</div> */}
        </div>
  )
}

export default NotificationsList